import { Button, Card } from '@/components'
import { cn } from '@/lib/utils'
import { Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { isBrowser, isMobile } from 'react-device-detect'

interface Props {
  loading: boolean

  numAbsences: number
  totalAbsences: number
  numApprove: number
  numReject: number
  hasActions: boolean

  onClear(): void
  onSubmit(): void
}

export function AbsenceRequestsInfobar({
  loading,

  numAbsences,
  totalAbsences,
  numApprove,
  numReject,
  hasActions,

  onClear,
  onSubmit,
}: Props) {
  const translations = useTranslate({
    showing: ['absences.requests.showing-n', { count: 0, total: 0 }],
    showingShort: ['absences.requests.showing-n-short', { count: 0, total: 0 }],
    reset: 'absences.requests.reset',
    save: 'absences.requests.save',

    reject: 'absences.requests.reject',
    approve: 'absences.requests.approve',
  })

  return (
    <Card
      className={cn(
        'fixed z-10 bottom-0 inset-x-0 rounded-none shadow-md-up',
        'md:sticky md:top-0 md:p-0 md:mb-4 md:rounded-xl md:shadow-card'
      )}
      contentClassName={cn(
        'flex items-center justify-between py-0 px-4',
        'md:h-16'
      )}
    >
      {loading ? (
        <div className="flex justify-center w-full">
          <Loader.Dots size={42} />
        </div>
      ) : (
        <>
          <div className="flex items-center">
            <span>
              {translations[isMobile ? 'showingShort' : 'showing']({
                count: numAbsences,
                total: totalAbsences,
              })}
            </span>

            {isBrowser && (
              <>
                {!!numApprove && (
                  <>
                    <span className="mx-4 text-gray-300">|</span>

                    <div className="rounded-md bg-green-100 px-2 py-1 text-sm text-green-800">
                      {translations.approve}: <strong>{numApprove}</strong>
                    </div>
                  </>
                )}

                {!!numReject && (
                  <>
                    <span className="mx-4 text-gray-300">|</span>

                    <div className="rounded-md bg-red-100 px-2 py-1 text-sm text-red-800">
                      {translations.reject}: <strong>{numReject}</strong>
                    </div>
                  </>
                )}
              </>
            )}
          </div>

          {!!hasActions && (
            <div className="flex gap-2">
              <Button variant="outline" size="sm" onClick={() => onClear()}>
                {translations.reset}
              </Button>

              <Button size="sm" onClick={() => onSubmit()}>
                {translations.save}
              </Button>
            </div>
          )}
        </>
      )}
    </Card>
  )
}
